/* @ngInject */
function viewOptionService (LocalStorageService) {
  const service = {
    set,
    get,
    setSearchView,
    getSearchView
  }
  return service

  function set (boardId, option) {
    LocalStorageService.set(`view-option-${boardId}`, option)
  }

  function setSearchView (option) {
    LocalStorageService.set('view-option-search', option)
  }

  function get (boardId) {
    const viewOption = LocalStorageService.get(`view-option-${boardId}`)

    return viewOption || 'kanban'
  }

  function getSearchView () {
    const viewOption = LocalStorageService.get('view-option-search')

    return viewOption || 'kanban'
  }
}

export { viewOptionService }
